// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import { useOrderTransactionTypes } from "@store/Framework/Common/Hooks/useOrderTransactionTypes";
import React, { FormEvent } from "react";

export interface OrderHistorySearchFieldTransactionTypeProps extends WidgetProps {}

export interface OrderHistorySearchFieldTransactionTypeStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const transactionTypeStyles: OrderHistorySearchFieldTransactionTypeStyles = {};
const styles = transactionTypeStyles;

const OrderHistorySearchFieldTransactionType: React.FC<OrderHistorySearchFieldTransactionTypeProps> = () => {
    const parameter = useAppSelector(state => state.pages.orderHistory.getOrdersParameter);
    const dispatch = useAppDispatch();
    const { transactionTypes, loadingTransactionTypes, transactionTypesError } = useOrderTransactionTypes();

    const handleChange = (event: FormEvent<HTMLSelectElement>) => {
        const selectedValue = event.currentTarget.value;
        if (selectedValue) {
            const matchedType = transactionTypes.find(type => type.key === selectedValue);
            dispatch(
                updateSearchFields({
                    transactionType: matchedType?.key,
                    transactionTypeDisplayName: matchedType?.value,
                }),
            );
        } else {
            dispatch(updateSearchFields({ transactionType: undefined }));
        }
    };

    const value = parameter?.transactionType || "";

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            <Select
                label={translate("Transaction Type")}
                {...styles.select}
                value={value}
                onChange={handleChange}
                disabled={loadingTransactionTypes || !!transactionTypesError}
                data-test-selector="orderHistory_filterTransactionType"
            >
                <option value="">{translate("Select")}</option>
                {transactionTypes.map(type => (
                    <option key={type.key} value={type.key}>
                        {type.value}
                    </option>
                ))}
            </Select>
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldTransactionType,
    definition: {
        group: "Order History",
        displayName: "Transaction Type Filter",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
